import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardModel, CardState } from '../../../games/models/game-view.model';
import { ResultChange } from '../../../services/result-change.service';
import { CardComponent } from '../card/card.component';
import { CardMessageComponent } from '../card-message/card-message.component';

@Component({
    selector: 'app-card-holder',
    standalone: true,
    imports: [CommonModule, CardComponent, CardMessageComponent],
    templateUrl: './card-holder.component.html',
    styleUrl: './card-holder.component.scss'
})
export class CardHolderComponent {
    @Input()
    card!: CardModel;

    protected readonly CardState = CardState;
    // When true, displays the card position values
    protected devMode = false;

    constructor(protected readonly resultChange: ResultChange) {}

    protected selectCard(card: CardModel): void {
        this.resultChange.selectCard(card);
    }

    protected revertCardValue(card: CardModel): void {
        this.resultChange.revert(card);
    }
}
